import { fromJS } from 'immutable';
import {
    GET_NEWS_REQUEST,
    GET_NEWS_SUCCESS,
    GET_NEWS_FAILURE,
    DELETE_NEWS_REQUEST,
    DELETE_NEWS_SUCCESS,
    DELETE_NEWS_FAILURE,
    PUT_NEWS_REQUEST,
    PUT_NEWS_SUCCESS,
    PUT_NEWS_FAILURE,
    POST_NEWS_REQUEST,
    POST_NEWS_SUCCESS,
    POST_NEWS_FAILURE,
} from './actions';

const initialState = fromJS({
    loadingGetNews: false,
    dataGetNews: null,
    errorGetNews: null,
    loadingDeleteNews: false,
    dataDeleteNews: null,
    errorDeleteNews: null,
    loadingPutNews: false,
    dataPutNews: null,
    errorPutNews: null,
    loadingPostNews: false,
    dataPostNews: null,
    errorPostNews: null,
});

const NewsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_NEWS_REQUEST:
            return state.set('loadingGetNews', true);
        case GET_NEWS_SUCCESS:
            return state.set('loadingGetNews', false).set('dataGetNews', action.payload);
        case GET_NEWS_FAILURE:
            return state.set('loadingGetNews', false).set('errorGetNews', action.error);
        case DELETE_NEWS_REQUEST:
            return state.set('loadingDeleteNews', true);
        case DELETE_NEWS_SUCCESS:
            return state.set('loadingDeleteNews', false).set('dataDeleteNews', action.payload);
        case DELETE_NEWS_FAILURE:
            return state.set('loadingDeleteNews', false).set('errorDeleteNews', action.error);
        case PUT_NEWS_REQUEST:
            return state.set('loadingPutNews', true);
        case PUT_NEWS_SUCCESS:
            return state.set('loadingPutNews', false).set('dataPutNews', action.payload);
        case PUT_NEWS_FAILURE:
            return state.set('loadingPutNews', false).set('errorPutNews', action.error);
        case POST_NEWS_REQUEST:
            return state.set('loadingPostNews', true);
        case POST_NEWS_SUCCESS:
            return state.set('loadingPostNews', false).set('dataPostNews', action.payload);
        case POST_NEWS_FAILURE:
            return state.set('loadingPostNews', false).set('errorPostNews', action.error);
        default:
            return state;
    }
};

export default NewsReducer;
